import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { COLORS, GAS_UNITS, MONTHS_IT, POWER_UNITS, fmtQty, toGasUnit, toPowerUnit } from "./eaFormat";
import { EaChartCard, HatchDefs } from "./EaUi";

export function axisFmt(v) {
  const a = Math.abs(v);
  if (a >= 1e6) return `${(v / 1e6).toLocaleString("it-IT", { maximumFractionDigits: 1 })} M`;
  if (a >= 1e3) return `${(v / 1e3).toLocaleString("it-IT", { maximumFractionDigits: 0 })} k`;
  return v.toLocaleString("it-IT", { maximumFractionDigits: 2 });
}

function ConsTooltip({ active, payload, unit, digits }) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  const v = d.actual ?? d.forecast;
  return (
    <div className="bg-white border border-slate-200 rounded-lg shadow-lg px-3 py-2 text-xs">
      <div className="font-semibold text-slate-900">{d.label}</div>
      <div className="text-slate-600">{v == null ? "Dato non disponibile" : `${fmtQty(v, digits, unit)} · ${d.actual != null ? "Consuntivo" : "Previsionale"}`}</div>
    </div>
  );
}

function ConsChart({ block, color, unit, digits, convert, testid, hatchId }) {
  const data = MONTHS_IT.map((label, i) => {
    const m = block.monthly[i];
    return { label, actual: convert(m.consumption_actual), forecast: convert(m.consumption_forecast) };
  });
  return (
    <div className="h-60" data-testid={testid}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <HatchDefs id={hatchId} color={color} />
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
          <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#64748B" }} axisLine={false} tickLine={false} />
          <YAxis tickFormatter={axisFmt} tick={{ fontSize: 11, fill: "#64748B" }} axisLine={false} tickLine={false} width={56}
            label={{ value: unit, angle: -90, position: "insideLeft", fontSize: 11, fill: "#64748B" }} />
          <Tooltip content={<ConsTooltip unit={unit} digits={digits} />} cursor={{ fill: "#F1F5F9" }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="actual" name="Consuntivo" stackId="c" fill={color} radius={[4, 4, 0, 0]} />
          <Bar dataKey="forecast" name="Previsionale" stackId="c" fill={`url(#${hatchId})`} stroke={color} strokeDasharray="3 2" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function EaConsumptionCharts({ power, gas, unit, unitToggle, gasUnit = "Smc", gasToggle }) {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
      {power.points > 0 && (
        <EaChartCard title="Consumi mensili Power" subtitle={`Unità: ${unit} · pieno = consuntivo, tratteggiato = previsionale`} right={unitToggle} testid="ea-card-consumption-power">
          <ConsChart block={power} color={COLORS.power} unit={unit} digits={POWER_UNITS[unit].digits}
            convert={(v) => toPowerUnit(v, unit)} testid="ea-chart-consumption-power" hatchId="ea-hatch-power" />
        </EaChartCard>
      )}
      {gas.points > 0 && (
        <EaChartCard title="Consumi mensili Gas" subtitle={`Unità: ${gasUnit} · pieno = consuntivo, tratteggiato = previsionale`} right={gasToggle} testid="ea-card-consumption-gas">
          <ConsChart block={gas} color={COLORS.gas} unit={gasUnit} digits={GAS_UNITS[gasUnit].digits} convert={(v) => toGasUnit(v, gasUnit)} testid="ea-chart-consumption-gas" hatchId="ea-hatch-gas" />
        </EaChartCard>
      )}
    </div>
  );
}
